module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_1250_Active@1x-2664b9216b343dbf3a226e600ecb20e2.png";